import { ProductSummary } from '@cart/shared-types';

export const PRODUCTS: ProductSummary[] = [
  {
    id: 'prod-001',
    name: 'Everyday Cotton Tote',
    slug: 'everyday-cotton-tote',
    category: 'bags',
    price: 2499,
    imageUrl: '/assets/products/everyday-cotton-tote.jpg',
    mediaSizeBytes: 0,
    stock: 14,
    active: true,
    createdAt: '2026-05-01T09:00:00.000Z',
  },
  {
    id: 'prod-002',
    name: 'Ceramic Pour Over Set',
    slug: 'ceramic-pour-over-set',
    category: 'kitchen',
    price: 5499,
    imageUrl: '/assets/products/ceramic-pour-over-set.jpg',
    mediaSizeBytes: 0,
    stock: 6,
    active: true,
    createdAt: '2026-05-04T09:00:00.000Z',
  },
  {
    id: 'prod-003',
    name: 'Walnut Desk Organizer',
    slug: 'walnut-desk-organizer',
    category: 'workspace',
    price: 3299,
    imageUrl: '/assets/products/walnut-desk-organizer.jpg',
    mediaSizeBytes: 0,
    stock: 0,
    active: true,
    createdAt: '2026-05-03T09:00:00.000Z',
  },
  {
    id: 'prod-004',
    name: 'Archived Linen Apron',
    slug: 'archived-linen-apron',
    category: 'kitchen',
    price: 1999,
    imageUrl: '/assets/products/archived-linen-apron.jpg',
    mediaSizeBytes: 0,
    stock: 4,
    active: false,
    createdAt: '2026-04-28T09:00:00.000Z',
  },
];
